
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {

document.querySelectorAll(".new_collection .card-wrapper").forEach(e=>{let t=e.querySelector(".new_collection .variant_select"),o=e.querySelectorAll(".new_collection .color_swatch,.new_collection .jod-quick-buy-button"),l=e.querySelectorAll(".new_collection .jod-quick-buy-button"),n=e.querySelectorAll(".new_collection .color_swatch,.new_collection .jod-quick-buy-button"),r=e.querySelector(".new_collection button#ProductSubmitButton-"),c=e.querySelector(".new_collection .product-variant-id"),i=e.querySelector(".new_collection .jod-quick-buy-title"),a=e.querySelector(".new_collection .card--media");if(!t||!o.length||!c)return;let s=t=>{e.classList.toggle("active",t)};i.addEventListener("click",()=>{document.querySelectorAll(".new_collection .card-wrapper").forEach(t=>{t!==e&&t.classList.remove("active")}),s(!e.classList.contains("active"))}),a.addEventListener("mouseleave",()=>{e.classList.remove("active")}),t.selectedIndex=0,c.value=t.value;let d=t.options[0].dataset.options.split("|");o.forEach(o=>{let l=parseInt(o.dataset.optionIndex),n=o.dataset.optionValue;d[l]===n&&o.classList.add("active"),o.addEventListener("click",()=>{d[l]=n,e.querySelectorAll('[data-option-index="'+l+'"]').forEach(e=>e.classList.remove("active")),o.classList.add("active");for(let e of t.options)if(e.dataset.options===d.join("|")){t.value=e.value,c.value=e.value;break}})}),t.addEventListener("change",()=>{c.value=t.value});(l.length?l:n).forEach(e=>{e.addEventListener("click",()=>{r.click()})})});let btns=document.querySelectorAll(".new_collection .title_inner button"),collections=document.querySelectorAll(".new_collection .product_inner .collection_main");collections.length&&(collections[0].style.display="block"),btns.length&&btns[0].classList.add("active");

btns.forEach(btn => {
  btn.addEventListener('click', () => {  
    let i = btn.dataset.indexIdPxl;
    btns.forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    collections.forEach(col => {
      col.style.display = col.dataset.index === i ? 'grid' : 'none';
    });
      $('.new_collection .collection_main').slick('refresh');
      $('.new_collection .card__inner.custom_product').each(function(index, element) {
        const $sliderFor = $(element).find('.slider-for');
        const $sliderNav = $(element).find('.slider-nav');
        if ($sliderFor.hasClass('slick-initialized')) {
          $sliderFor.slick('setPosition');
        }
        if ($sliderNav.hasClass('slick-initialized')) {
          $sliderNav.slick('setPosition');
        }
      });
    
    });
  });
  $('.new_collection .collection_main').slick({
    slidesToShow:4,
    slidesToScroll: 1, 
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev custom-prev"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="19" viewBox="0 0 10 19" fill="none"><path d="M9 1.67676L2.41421 8.26255C1.63316 9.04359 1.63316 10.3099 2.41421 11.091L9 17.6768" stroke="white" stroke-width="2"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next custom-next"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="19" viewBox="0 0 10 19" fill="none"><path d="M1 17.6768L7.58579 11.091C8.36684 10.3099 8.36684 9.04359 7.58579 8.26254L1 1.67676" stroke="black" stroke-width="2"/></svg></button>',
     autoplay: true,
     autoplaySpeed: 3000,
     cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
    infinite: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
          $('.new_collection .card__inner.custom_product').each(function() {
        const $sliderFor = $(this).find('.slider-for');
        const $sliderNav = $(this).find('.slider-nav'); 
        $sliderFor.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
    //        autoplay: true,
    //  autoplaySpeed: 3000,
    //  cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
          infinite: false,
          draggable: false,
          arrows: true,
          prevArrow: '<button type="button" class="slick-prev custom-prev"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="19" viewBox="0 0 10 19" fill="#fff"><path d="M9 1.67676L2.41421 8.26255C1.63316 9.04359 1.63316 10.3099 2.41421 11.091L9 17.6768" stroke="white" stroke-width="2"/></svg></button>',
          nextArrow: '<button type="button" class="slick-next custom-next"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="19" viewBox="0 0 10 19" fill="#fff"><path d="M1 17.6768L7.58579 11.091C8.36684 10.3099 8.36684 9.04359 7.58579 8.26254L1 1.67676" stroke="black" stroke-width="2"/></svg></button>',
          fade: true,
          asNavFor: $sliderNav
        });
      
        $sliderNav.slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          asNavFor: $sliderFor,
          dots: false,
          infinite: false,
          centerMode: false,
          arrows: false,
          focusOnSelect: true,
          responsive: [{
            breakpoint: 1024,
            settings: { slidesToShow: 4 }
          }]
        });
        $sliderNav.find('.slick-slide').removeClass('slick-current');
        $sliderNav.find('.slick-slide[data-slick-index="0"]').addClass('slick-current');
        $sliderFor.on('afterChange', function(event, slick, currentSlide) {
          $sliderNav.find('.slick-slide').removeClass('slick-current');
          $sliderNav.find('.slick-slide[data-slick-index="'+currentSlide+'"]').addClass('slick-current');
        });
      });
        }, 1500);
  });
